import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appDropdown]', exportAs: 'appDropdown'
})
export class DropdownDirective {
  @HostBinding('class.dropdown') readonly dropdownClass = true;
  @HostBinding('class.show') isOpen = false;

  constructor(private el: ElementRef) { }

  toggle() { this.isOpen = !this.isOpen; }

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: HTMLElement) {
    if (!this.el.nativeElement.contains(target)) {
      this.isOpen = false;
    }
  }
}

@Directive({ selector: '[appDropdownToggle]' })
export class DropdownToggleDirective {
  constructor(private dropdown: DropdownDirective) { }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.dropdown.toggle();
  }
}

@Directive({ selector: '[appDropdownMenu]' })
export class DropdownMenuDirective {
  @HostBinding('class.dropdown-menu') readonly menuClass = true;
  @HostBinding('class.show') get showClass() { return this.dropdown.isOpen; }

  constructor(private dropdown: DropdownDirective) { }
}
